'use client'

import { useEffect, useState } from 'react'

export const useColumnCount = (): number => {
  const getColumns = () => {
    if (window.innerWidth < 640) return 1
    if (window.innerWidth < 1024) return 2
    return 3
  }

  const [columns, setColumns] = useState(3)

  useEffect(() => {
    let timeout: NodeJS.Timeout

    const handleResize = () => {
      clearTimeout(timeout)

      timeout = setTimeout(() => {
        setColumns(getColumns())
      }, 100)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      clearTimeout(timeout)

      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return columns
}
